module.exports = __webpack_public_path__ + "static/media/81QKtaD1vSL._AC_SL1500_.8680c1be.jpg";